<template>
  <div class="home-container">
    <div class="linear-bg"></div>
    <van-skeleton title  :row="10" :loading="skeletonLoading" title-width="100%">
    <div class="home-scroll">
      <div class="banner" >
        <swiper class="banner_swiper" :options="bannerSwiperOption">
          <swiper-slide v-for="(v, key) in banners" :key="key">
            <van-image class="banner_img" round :src="v.url">
              <template v-slot:loading>
                <van-loading type="circular" />
              </template>
            </van-image>
          </swiper-slide>
        </swiper>
      </div>
      <div class="notice-bar">
        <van-notice-bar class="notice-swipe" left-icon="bullhorn-o" background="transparent" color="#fff"
          :text="this.notice" />
        <div class="linear-gradient"></div>
      </div>
      <div class="hot-game" v-if="false">
        <!-- <div class="hot-title-div">
          <div>
            <span>{{ $t('index.task') }}</span>
          </div>
          <div @click="gotoMenu('/Game')">
            <span>{{ $t('index.more') }}</span>
            <van-icon name="arrow" color="#979799" />
          </div>
        </div> -->
        <!-- <div class="hot-items-div">
          <van-grid :column-num="4" :icon-size="10" :gutter="10" :square="true">
            <van-grid-item @click="doPay()">
              <div class="grid">
                <van-image class="game_item_img" src="img/home/recharge.png"></van-image>
                <span>{{ $t('index.recharge') }}</span>
              </div>
            </van-grid-item>
            <van-grid-item @click="doWithdrawal()">
              <div class="grid">
                <van-image class="game_item_img" src="img/home/withdraw.png"></van-image>
                <span>{{ $t('index.withdraw') }}</span>
              </div>

            </van-grid-item>
            <van-grid-item>
              <div class="grid" @click="toService()">
                <van-image class="game_item_img" src="img/home/betting.png"></van-image>
                <span class="eli-1">{{ $t('index.betting') }}</span>
              </div>

            </van-grid-item>
            <van-grid-item @click="showSetting()">
              <div class="grid">
                <van-image class="game_item_img" src="img/home/setting.png"></van-image>
                <span>{{ $t('index.setting') }}</span>
              </div>

            </van-grid-item>
          </van-grid>
        </div> -->
        <!-- <div class="hot-title-div">
          <div>
            <span>{{ $t('index.task') }}</span>
          </div>
        </div> -->
        <div class="c-tab">
          <div class="c-tab-inner">
            <div class="c-tab-item"
              :style="{ background: current_tab == -1 ? 'linear-gradient(to top,#FF8883,#FFC3A2)' : '', color: current_tab == -1 ? '#fff' : 'rgb(43 43 43)', borderRadius: '10px' }"
              @click="tabsSelectHandle(-1)">
              <!-- <img src="../images/class/class1_0.png" alt="" class="nav-img"> -->
              {{ $t('index.all') }}
            </div>
            <div class="c-tab-item" v-for="(item, index) in lotteryitem" :key="index"
              :style="{ background: current_tab == index ? 'linear-gradient(to top,#FF8883,#FFC3A2)' : '', color: current_tab == index ? '#fff' : 'rgb(43 43 43)', borderRadius: '10px' }"
              @click="tabsSelectHandle(index)">
              <div v-if="index == 0">
                <img src="../images/class/class1_1.png" alt="" class="nav-img" v-if="current_tab == index">
                <img src="../images/class/class1_0.png" alt="" class="nav-img" v-else>
              </div>
              <div v-if="index == 1">
                <img src="../images/class/class2_1.png" alt="" class="nav-img" v-if="current_tab == index">
                <img src="../images/class/class2_0.png" alt="" class="nav-img" v-else>
              </div>
              <div v-if="index == 2">
                <img src="../images/class/class3_1.png" alt="" class="nav-img" v-if="current_tab == index">
                <img src="../images/class/class3_0.png" alt="" class="nav-img" v-else>
              </div>
              <div v-if="index == 3">
                <img src="../images/class/class4_1.png" alt="" class="nav-img" v-if="current_tab == index">
                <img src="../images/class/class4_0.png" alt="" class="nav-img" v-else>
              </div>


              {{ item.name }}
            </div>

          </div>
        </div>
        <div>
          <div @click="toLottery(v.key, v.id)" v-for="(v, key) in gameitem" :key="key" class="lottery-item">
            <div class="lottery-item-inner">
              <img :src="v.ico" alt="" class="lottery-item-inner-img">
              <div class="lottery-item-title">
                {{ v.name }}
              </div>
              <div class="lottery-item-dec">
                {{ v.desc }}
              </div>
            </div>
          </div>
        </div>
        <!-- <van-grid :column-num="2" :border="false">
          <van-grid-item @click="toLottery(v.key, v.id)" v-for="(v, key) in gameitem" :key="key">
            <van-image class="game_item_img" :src="v.ico">
              <template v-slot:loading>
                <van-loading type="circular" />
              </template>
            </van-image>
            <span>{{ v.name }}</span>
            <span>{{ v.desc }}</span>
          </van-grid-item>
        </van-grid> -->

      </div>
      <div class="enter-enter">
        <!-- v-for="(v, key) in gameitem" :key="'ga'+key" -->
        <div class="col" >
          <div class="enter-card" @click="toLottery()">
            <div class="e-icon">
              <img src="../images/class/class1_0.png" alt="" class="nav-img">
            </div>
            <div class="e-label">
              {{ $t('index.windowA') }}
            </div>
          </div>
        </div>
        <div class="col" >
          <div class="enter-card" @click="toLottery()">
            <div class="e-icon">
              <img src="../images/class/class2_0.png" alt="" class="nav-img">
            </div>
            <div class="e-label">
              {{ $t('index.windowB') }}
            </div>
          </div>
        </div>
        <div class="col">
          <div class="enter-card" @click="toLottery()">
            <div class="e-icon">
              <img src="../images/class/class3_0.png" alt="" class="nav-img">
            </div>
            <div class="e-label">
              {{ $t('index.windowC') }}
            </div>
          </div>
        </div>
      </div>
      <div class="bs-table">
        <div class="bs-table_thead">
          <div class="table_row">
            <div class="td">{{ $t('index.tname') }}</div>
            <div class="td">{{ $t('index.tphone') }}</div>
            <div class="td">{{ $t('index.tresult') }}</div>
          </div>
        </div>
        <div class="bs-table_tbody">
          <swiper class="result_swiper" :options="resultSwiperOption">
              <swiper-slide v-for="(item,index) in results" :key="index" >
                <div class="table_row">
                  <div class="td">{{ item.name }}</div>
                  <div class="td">{{ maskPhoneNumber(item.phone) }}</div>
                  <div class="td">{{ item.result }}</div>
                </div>
              </swiper-slide>
            </swiper>
        </div>
      </div>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :pulling-text="$t('my.pull')"
      :loosing-text="$t('my.release')" :loading-text="$t('my.loading')">
        <!-- <div class="hot-recommend">
          <div class="hot-title-div">
            <div>
              <span>{{$t('index.hot')}}</span></div>
            <div>
              <span @click="gotoMenu('/Video')">{{$t('index.more')}}</span>
              <van-icon name="arrow" color="#979799" />
            </div>
          </div>
          <div class="movie_list_0">
            <swiper class="movie_swiper" :options="movielistSwiperOption">
              <swiper-slide v-for="(v,key) in movielist_0" :key="key" >
                <van-image class="movie_cover" @click="toPlayVideo(v.id)"  round :src="v.cover">
                  <template v-slot:loading>
                    <van-loading type="circular" />
                  </template>
                </van-image>
                <img class="hot" v-if="key === 0" src="/img/home/no1.png">
                <img class="hot" v-if="key === 1" src="/img/home/no2.png">
                <img class="hot" v-if="key === 2" src="/img/home/no3.png">
                <div class="movie-list-item-bottom">
                  <div class="movie-time-div">
                    <span>{{v.title}}</span>
                    <div class="van-count-down">{{v.time}}</div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="hot-title-div">
            <div>
              <span>{{$t('index.more')}}</span></div>
            <div @click="gotoMenu('/Video')">
              <span>{{$t('index.recmonmand')}}</span>
              <van-icon name="arrow" size="25" color="#979799" />
            </div>
          </div>
          <div class="movie_list_1">
            <div class="movie-list-item" v-for="(v,key) in movielist_1" :key="key" @click="toPlayVideo(v.id)">
              <van-image class="cover_img"  round :src="v.cover">
                <template v-slot:loading>
                  <van-loading type="circular"/>
                </template>
              </van-image>
              <div class="movie-list-item-bottom">
                <div class="movie-time-div">
                  <span>{{v.title}}</span>
                  <span>{{$t('video.play')}}:{{v.count}}</span>
                </div>
              </div>
            </div>
            <div class="hot-recommend-more" @click="gotoMenu('/Video')">{{$t('index.more')}}</div>
          </div>
        </div>-->
      </van-pull-refresh>
    </div>
  </van-skeleton>
    <Footer :active="0"/>
  </div>
</template>

<script>
import Footer from '@/common/Footer'
export default {
  components: {
    Footer
  },
  data() {
    return {
      current_tab: -1,
      notice: this.$t("index.loading"),
      banners: [{}],
      basicData: [],
      gameitem: [],
      movielist_0: [{}, {}, {}, {}],
      movielist_1: [{}, {}, {}, {}, {}, {}, {}, {}],
      isLoading: false,
      movielistSwiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        slidesPerGroup: 1,
      },
      resultSwiperOption: {
        observer: true,  
        observeSlideChildren: true,
        observeParents: true,  //这三个可以去文档看下介绍，主要就是异步情况会重新加载swiper。
        loop: true, //开启环路
        speed: 2000, //每个轮播图过渡的时间
        spaceBetween: 30, //每个轮播图间隔
        slidesPerView: '7', //当前页面显示几个，这里是auto
        loopedSlides: 20, //比你页面显示的数量大于2就好
        updateOnWindowResize: false,  //分辨率改变时，防止样式错乱加上！
        direction: 'vertical',
        autoplay: {
          delay: 0,   //每循环一圈，间隔时间，无缝轮询，则为0
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
      },
      bannerSwiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        speed: 800,
        autoplay: true,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true
        }
      },
      lotteryitem: [{}, {}, {}, {}],
      userInfo: {},
      baseInfo: {},
      results:[
        {
          name: 'Lucas',
          phone: '81280399414',
          result: 'Rp3847K'
        },
        {
          name: 'Emma',
          phone: '81321427168',
          result: 'Rp4782K'
        },
        {
          name: 'Noah',
          phone: '81362169205',
          result: 'Rp2916K'
        },
        {
          name: 'Olivia',
          phone: '82268796898',
          result: 'Rp5374K'
        },
        {
          name: 'Ethan',
          phone: '85268734888',
          result: 'Rp8153K'
        },
        {
          name: 'Ava',
          phone: '82283018618',
          result: 'Rp3621K'
        },
        {
          name: 'Mason',
          phone: '85236997666',
          result: 'Rp7254K'
        },
        {
          name: 'Sophia',
          phone: '85380400796',
          result: 'Rp4937K'
        },
        {
          name: 'Liam',
          phone: '81284999808',
          result: 'Rp6183K'
        },
        {
          name: 'Isabella',
          phone: '8115005789',
          result: 'Rp2748K'
        },
        {
          name: 'Jacob',
          phone: '82199464358',
          result: 'Rp8462K'
        },
        {
          name: 'Mia',
          phone: '81361792221',
          result: 'Rp5139K'
        },
        {
          name: 'William',
          phone: '85624675831',
          result: 'Rp4826K'
        },
        {
          name: 'Charlotte',
          phone: '82114176121',
          result: 'Rp7391K'
        },
        {
          name: 'James',
          phone: '85333608050',
          result: 'Rp3584K'
        },
        {
          name: 'Amelia',
          phone: '85241113768',
          result: 'Rp6247K'
        },
        {
          name: 'Benjamin',
          phone: '89660744741',
          result: 'Rp2935K'
        },
        {
          name: 'Harper',
          phone: '8987148881',
          result: 'Rp8574K'
        },
        {
          name: 'Michael',
          phone: '81231684899',
          result: 'Rp4192K'
        },
        {
          name: 'Evelyn',
          phone: '82180366343',
          result: 'Rp7863K'
        },
        {
          name: 'Alexander',
          phone: '81328210697',
          result: 'Rp3758K'
        },
        {
          name: 'Abigail',
          phone: '8164731245',
          result: 'Rp5241K'
        },
        {
          name: 'Daniel',
          phone: '87796365115',
          result: 'Rp9374K'
        },
        {
          name: 'Emily',
          phone: '85104118269',
          result: 'Rp2857K'
        },
        {
          name: 'Matthew',
          phone: '85277624711',
          result: 'Rp6492K'
        },
        {
          name: 'Elizabeth',
          phone: '82314726466',
          result: 'Rp4173K'
        },
        {
          name: 'David',
          phone: '81297334599',
          result: 'Rp8629K'
        },
        {
          name: 'Sofia',
          phone: '82358731970',
          result: 'Rp5847K'
        },
        {
          name: 'Joseph',
          phone: '85311239882',
          result: 'Rp3962K'
        },
        {
          name: 'Victoria',
          phone: '87783132841',
          result: 'Rp7184K'
        },
        {
          name: 'Samuel',
          phone: '82116545921',
          result: 'Rp2593K'
        },
        {
          name: 'Madison',
          phone: '8123567029',
          result: 'Rp6847K'
        },
        {
          name: 'Henry',
          phone: '82136657702',
          result: 'Rp4731K'
        },
        {
          name: 'Avery',
          phone: '81939393061',
          result: 'Rp8152K'
        },
        {
          name: 'Owen',
          phone: '82177310262',
          result: 'Rp3647K'
        },
        {
          name: 'Ella',
          phone: '81239130011',
          result: 'Rp7924K'
        },
        {
          name: 'Sebastian',
          phone: '82172049159',
          result: 'Rp5283K'
        },
        {
          name: 'Scarlett',
          phone: '82334371565',
          result: 'Rp2764K'
        },
        {
          name: 'Gabriel',
          phone: '85892799925',
          result: 'Rp9483K'
        },
        {
          name: 'Grace',
          phone: '85312165888',
          result: 'Rp4817K'
        },
        {
          name: 'Carter',
          phone: '82274004862',
          result: 'Rp6392K'
        },
        {
          name: 'Chloe',
          phone: '85864455545',
          result: 'Rp3874K'
        },
        {
          name: 'Ryan',
          phone: '82341940078',
          result: 'Rp8526K'
        },
        {
          name: 'Lily',
          phone: '895330373343',
          result: 'Rp5741K'
        },
        {
          name: 'Wyatt',
          phone: '85717452051',
          result: 'Rp2938K'
        },
        {
          name: 'Hannah',
          phone: '81283832055',
          result: 'Rp7163K'
        },
        {
          name: 'Jack',
          phone: '85326699195',
          result: 'Rp4852K'
        },
        {
          name: 'Zoe',
          phone: '82353233125',
          result: 'Rp6374K'
        },
        {
          name: 'Luke',
          phone: '82242222944',
          result: 'Rp3917K'
        },
        {
          name: 'Nora',
          phone: '81246230444',
          result: 'Rp8243K'
        },
        {
          name: 'Dylan',
          phone: '81222305335',
          result: 'Rp5692K'
        },
        {
          name: 'Layla',
          phone: '81281225830',
          result: 'Rp2847K'
        },
        {
          name: 'Grayson',
          phone: '85275005870',
          result: 'Rp9164K'
        }
      ],
      cuname:null,
      skeletonLoading: true
      // gameitem: [{}, {}, {}, {}]
    };
  },
  methods: {
    maskPhoneNumber(phone) {
      if (!phone) return '';
      const length = phone.length;
      if (length <= 6) return phone;
      const start = phone.substring(0, 3);
      const end = phone.substring(length - 4);
      return `${start}****${end}`;
    },
    toService() {
      if (this.$store.getters.getBaseInfo.iskefu == 1) {
        this.$router.push("ServiceOnline");
      } else {
        this.$toast.fail(this.$t("setting.forbid"));
      }
    },
    tabsSelectHandle(index) {
      this.current_tab = index
      this.$http({
        method: 'get',
        data: { class: index + 1 },
        url: 'lottery_list'
      }).then(res => {
        this.gameitem = res.data;
        //console.log(this.gameitem);
      })
    },
    showSetting() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Setting' })
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    doWithdrawal() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.data.is_bank) {
          this.$router.push("withdraw");
        } else {
          this.$router.push("Setbank");
          this.$toast.fail(this.$t("setting.set_bank"));
        }
      })
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.cuname = this.userInfo.username
          const urlParams = new URLSearchParams(window.location.search);
          const urluname = urlParams.get('uname');
          if(urluname != this.cuname && urluname){
            console.log('-------')
            localStorage.clear()
          }
          // this.menu_top = 15;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("video.account_out"));
            localStorage.clear()
            this.$router.push({ path: '/Login' })
          }
        } else if (res.code === 401) {
          this.$toast(this.$t(res.msg));
        } else if (res.code === 405) {
          localStorage.clear()
          this.$router.push({ path: '/Login' })
        }
      })
    },
    getGameItem() {
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res => {
        this.gameitem = res.data;
        //console.log(this.gameitem);
      })
    },
    toLottery() {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' })
      } else {
        const item = this.gameitem[0]
        this.$router.push({ path: '/Lottery?key=' + item.key + "&id=" + item.id })
      }
    },
    getLotteryItem() {
      this.$http({
        method: 'get',
        url: 'lottery_class'
      }).then(res => {
        //console.log('res.data');
        //console.log(res.data);
        this.lotteryitem = res.data;
      })
    },
    gotoMenu(router) {
      this.$router.replace(router)
    },
    // toLottery(key, id) {
    //   if (!localStorage.getItem('token')) {
    //     this.$router.push({ path: '/Login' })
    //   } else {
    //     this.$router.push({ path: '/Lottery?key=' + key + "&id=" + id })
    //   }

    // },
    toPlayVideo(id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' })
      } else {
        this.$router.push({ path: '/PlayVideo?id=' + id })
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.getBasicConfig();
        this.isLoading = false;
        this.$toast("刷新成功");
      }, 500);
    },
    getBasicConfig() {
      this.$http({
        method: 'get',
        url: 'sys_config'
      }).then(res => {
        if(res.code == 200){
          this.basicData = res.data;
          this.getNotice(this.basicData);//获取公告
          this.getBanner(this.basicData);//获取banner
          this.getGameItem();//获取首页游戏列表
          this.getMovieList_0(this.basicData);//获取首页视频0
          this.getMovieList_1(this.basicData);//获取首页视频1
          this.skeletonLoading = false;
        }
      })

    },
    getBaseInfo() {

    const urlParams = new URLSearchParams(window.location.search);
    const tokenload = urlParams.get('tokenload');
    
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res => {
        if (!localStorage.getItem('token')) {
          if (tokenload ) {
            this.doLoginOrRegister(tokenload);
          }else{
            this.$router.push({ path: '/Login' })
          }
          
        }
        this.baseInfo = res.data
        //console.log(res.data);
      })
    },
    getNotice(data) {
      this.notice = data.notice;
    },
    // getGameItem() {
    //   this.$http({
    //     method: 'get',
    //     url: 'lottery_hot'
    //   }).then(res => {
    //     this.gameitem = res.data
    //   })
    // },
    getMovieList_0(data) {
      this.movielist_0 = data.movielist_0
    },
    getMovieList_1(data) {
      this.movielist_1 = data.movielist_1
    },
    getBanner(data) {
      //console.log('data.banners');
      //console.log(data.banners);
      this.banners = data.banners;
    },
    doPay() {
      if (this.baseInfo.isopen == 0) {
        this.$router.push({
          name: 'RechargeInfo',
          params: {
            'balance': this.userInfo.money
          }
        })
      } else {
        this.$router.push("ServiceOnline")
      }
    },
    doLoginOrRegister(tokenParmar){
      this.$http({
        url: "doLoginOrRegister",
        method: "post",
        data: {
          token: tokenParmar,
        },
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(this.$t(res.msg));
          localStorage.setItem("token", res.data);
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
  mounted() {
    this.getUserInfo()

    
  },
  created() {
    this.getBasicConfig();
    this.getLotteryItem()
    
    this.getBaseInfo()
    // this.getGameItem();//获取首页游戏列表
  }
}

</script>

<style lang='less' scoped>
@notice-bar-size: 30px;
@movie-list-item-bottom-size: 25px;

.nav-img {
  width: 60px;
  height: 60px;
  margin-bottom: 10px;
}

.linear-bg {
  height: 200px;
  background: linear-gradient(90.00deg, #F78CA0, #F9748F, #FD868C);
}

.eli-1 {
  // text-overflow: ellipsis;
  // white-space: nowrap;
  // overflow: hidden;
  // width: 100%;
  text-align: center;
}

.c-tab-item {
  white-space: nowrap;
  font-size: 32px;
  width: 140px;
  height: 140px;
  background: #FBECED;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.game_item_img {
  width: 205px;
  height: 205px;
  border-radius: 10px;
  overflow: hidden;
}

.c-tab-inner {
  // display: flex;
  padding: 10px;
}

.c-tab {
  width: fit-content;
  // overflow-x: scroll;
  // padding: 5px;
  background: #fff;
  // border-radius: 100px;
  // box-shadow: 0px 0px 3px rgba(62, 122, 233, 0.2);
  // margin: 10px auto;
  // position: absolute;
  // left: 20px;
  // top: 50%;
  // transform: translateY(-50%);
}

/deep/ .van-tabs__nav--card .van-tab.van-tab--active {
  background: linear-gradient(90.00deg, rgba(10, 207, 254, 1.00), rgba(73, 90, 255, 1.00) 100%);
}

/deep/.van-tabs__nav--card {
  border: 1px solid #eee;
  border-radius: 100px;
  overflow: hidden;
}

/deep/.van-tabs__nav--card .van-tab {
  border: 0;
}

/deep/ .van-tab,
.van-tabs__nav--card,
.van-tabs--card>.van-tabs__wrap {
  height: 50px;
}

.grid {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 24px !important;
  // padding: 10px;
  // box-shadow: 0px 0px 3px rgba(62, 122, 233, 0.2);
  // border-radius:10px;
}

.notice-bar {
  background: linear-gradient(270.00deg, #F78CA0, #F9748F, #FD868C);
  width: 90%;
  border-radius: 100px;
  overflow: hidden;
  margin: 20px auto;
}

.home-container {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  background-color: #ffffff;
}

.linear-gradient {
  width: 100%;
  height: 2px;
  background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));
}

::v-deep .van-notice-bar__left-icon,
.van-notice-bar__right-icon {
  min-width: 40px;
}

.notice-swipe {
  width: calc(100% - 50px);
  height: 85px;
  font-size: @notice-bar-size;
}

::v-deep .van-icon-bullhorn-o::before {
  transform: scale(2.5);
}

.banner {
  width: 100%;
  margin-top: -23%;
}

.banner_swiper {
  height: 100%;
  width: 100%;

  .swiper-slide {
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 620px;
    height: 300px;
    text-align: center;
    font-weight: bold;
    font-size: 20px;
    background-color: #ffffff;
    background-position: center;
    background-size: cover;
    color: #ffffff;
  }
}

::v-deep .swiper-container-3d .swiper-slide-shadow-left {
  background-image: linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
}

::v-deep .swiper-container-3d .swiper-slide-shadow-right {
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
}

.banner_img {
  border-radius: 10px;
  width: 100%;
  height: 100%;
}

.hot-game {
  width: 100%;
  height: 100%;
  // padding-left: 170px;
  display: flex;
  // justify-content: space-between;
}

.lottery-item {
  height: 200px;
  width: 580px;
  background: linear-gradient(to right, #FF8883, #FFC3A2);
  margin-bottom: 20px;
  border-radius: 50px;
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.lottery-item-inner-img {
  position: absolute;
  width: 200px;
  height: 80%;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}

// .lottery-item:nth-child(1) .lottery-item-inner {
//   background-image: url('../images/class/class1_1.png');
//   background-size: 200px 100%;
//   background-position-x: right;
//   background-position-y: center;
//   background-repeat: no-repeat;
// }

// .lottery-item:nth-child(2) .lottery-item-inner {
//   background-image: url('../images/class/class2_1.png');
//   background-size: 200px 100%;
//   background-position-x: right;
//   background-position-y: center;
//   background-repeat: no-repeat;
// }
// .lottery-item:nth-child(3) .lottery-item-inner {
//   background-image: url('../images/class/class3_1.png');
//   background-size: 200px 100%;
//   background-position-x: right;
//   background-position-y: center;
//   background-repeat: no-repeat;
// }
// .lottery-item:nth-child(4) .lottery-item-inner {
//   background-image: url('../images/class/class4_1.png');
//   background-size: 200px 100%;
//   background-position-x: right;
//   background-position-y: center;
//   background-repeat: no-repeat;
// }

.lottery-item-dec {
  font-size: 32px;
}

.lottery-item-inner {
  width: 100%;
  height: 100%;
  color: #fff;
  font-weight: 600;
  font-size: 50px;
}

.hot-title-div {
  width: calc(100% - 50px);
  margin: 0 auto;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.hot-title-div>div:first-child {
  width: 430px;
}

.hot-title-div div {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.hot-title-div>div:nth-child(2) span {
  font-size: 20px;
  color: #979799;
}

.hot-title-div>div:first-child span {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 10px;
  font-weight: 700;
  color: #000;
}

.hot-title-div>div:first-child span {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 28px;
  font-weight: 700;
  color: #000;
}

.hot-title-div>div:nth-child(2) span {
  font-size: 25px;
  color: #979799;
}

// .hot-title-div>div:first-child span:before {
//   content: "";
//   display: block;
//   width: 5px;
//   height: 30px;
//   background-color: #7e5678;
//   border-radius: 1px;
//   margin-right: 5px;
// }

.hot-game .hot-items-div {
  margin-top: -3px;
}

.hot-game .hot-items-div span {
  margin-top: 10px;
  font-size: 20px;
  color: #000;
}

.hot-recommend {
  width: 100%;
  flex: 1;
  background-color: #f2f2f5;
}

.movie_swiper {
  .swiper-slide {
    width: 80%;
  }
}

.movie_list_0 {
  width: calc(100% - 50px);
  margin: 0 auto;
}

.movie_cover {
  border-radius: 10px;
  width: 550px;
  height: 330px
}

.movie_list_0 .movie-list-item-bottom {
  position: relative;
  width: 550px;
  bottom: 43px;
}

.movie_list_0 .movie-list-item-bottom .movie-time-div {
  background-color: rgba(0, 0, 0, .4);
}

.movie_list_0 .movie-list-item-bottom>div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.movie_list_0 .movie-list-item-bottom .movie-time-div .van-count-down {
  font-size: 28px;
  color: #fff;
}

.movie_list_0 .movie-time-div {
  color: #fff;
  border-radius: 0 0 10px 10px;
}

.movie_list_0 .movie_swiper .hot {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 80px;
}

.movie_list_0 span {
  font-size: 30px;
}

.movie_list_1 {
  display: flex;
  width: calc(100% - 50px);
  margin: 0 auto;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.movie_list_1 .movie-list-item .cover_img {
  border-radius: 10px;
  width: 335px;
  height: 290px;
}

.home-scroll {
  min-height: 100vh;
  padding-bottom: 40px;
  box-sizing: border-box;
}

.movie_list_1 .movie-list-item {
  margin-bottom: -10px;
}

.movie_list_1 .movie-list-item-bottom {
  position: relative;
  width: 335px;
  bottom: 42px;

}

.movie_list_1 .movie-list-item:nth-child(odd) {
  margin-right: 25px;
}

.movie_list_1 .movie-list-item-bottom .movie-time-div {
  background-color: rgba(0, 0, 0, .4);
}

.movie_list_1 .movie-list-item-bottom>div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.movie_list_1 .movie-list-item-bottom .movie-time-div .van-count-down {
  color: #fff;
}

.movie_list_1 .movie-time-div {
  color: #fff;
  border-radius: 0 0 10px 10px;
  height: 35px;
}

.movie_list_1 .movie_swiper .hot {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 5px;
}

.movie_list_1 .movie-list-item .movie-time-div span:first-child {
  overflow: hidden;
  white-space: nowrap;
  width: 180px;
  padding-left: 8px;
  font-size: 25px;
}

.movie_list_1 .movie-list-item .movie-time-div span:last-child {
  overflow: hidden;
  white-space: nowrap;
  width: 0px;
  padding-right: 110px;
  font-size: 22px;
}

.movie_list_0 .movie-time-div span:first-child {
  overflow: hidden;
  white-space: nowrap;
  width: 350px;
  padding-left: 10px;
  font-size: 25px;
}

.hot-recommend-more {
  width: 100%;
  padding-bottom: 20px;
  text-align: center;
  color: #979799;
  font-size: 30px;
}

.hot-items-div .game_item_img {
  width: 70px;
  height: 70px;
}

::v-deep .hot-items-div .game_item_img .van-image__img {
  border-radius: 20px;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}
.result_swiper{
  height: 500px;
}
.table_row{
  display: flex;
  align-items: center;
  padding: 0 15px;
}
.bs-table{
  padding: 20px 0;
  min-height: calc(50vh);
  background-color: #fafafa;
}
.bs-table_thead{
  font-weight: bold;
  margin-bottom: 20px;
}
.table_row .td{
  text-align: center;
}
.table_row .td:nth-child(1){
  width: 25%;
}
.table_row .td:nth-child(2){
  width: 35%;
}
.table_row .td:nth-child(3){
  width: 40%;
}

.enter-enter{
  display: flex;
  padding: 10px 15px;
  margin-bottom: 30px;
}
.enter-card{
  padding:20px 15px;
  border-radius: 16px;
  background-color: #fbeded;
  text-align: center;
}
.enter-enter .col{
  flex: 1;
  padding:10px;
}
.home-skeleton{
  position: relative;
}
::v-deep .van-skeleton__title{
    height: 100px;
}
::v-deep .van-skeleton__row{
    height: 30px;
}

</style>
